<template>
    <div class="rezultati-single">
        <!-- navbar -->
        <Navbar showBackButton></Navbar>

        <!-- poveznice -->
        <div class="poveznice">
            <Poveznice></Poveznice>
        </div>

        <div class="container">
            <Loading :loadingState="rezultatiLoadingState">
                <template v-if="hasAnyUserAnswers">
                    <RezultatiPanel :statistics="userAnswersStatistics.statistics" :userData="userAnswersStatistics.userData"></RezultatiPanel>
                    <ul class="rezultati-pitanja">
                        <li v-for="(userAnswer, key) in userAnswersObject" v-bind:key="key">
                            <RezultatiCard :userAnswer="userAnswer[1]" :questionId="getUserAnswerKey(userAnswer) + 1" :correctAnswer="getCorrectAnswer(userAnswer)"></RezultatiCard>
                        </li>
                    </ul>
                    <div class="cards">
                        <router-link to="/rezultati" class="button-1 red"><span>Svi rezultati</span></router-link>
                    </div>
                </template>
                <template v-if="!hasAnyUserAnswers">
                    <p class="no-results"></p>
                    <NoResults message="Nisu pronađeni rezultati za ovog korisnika"></NoResults>
                </template>
                <template v-slot:error>
                    <!-- TODO: Error message vjv nije oke pa korigirati -->
                    <ErrorMessageText></ErrorMessageText>
                </template>
            </Loading>
        </div>
    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Poveznice from '../components/Poveznice.vue'
import RezultatiPanel from '../components/RezultatiSinglePanel.vue'
import RezultatiCard from '../components/RezultatiSingleCard.vue'
import Loading from '../components/common/Loading.vue'
import LoadingState from './../utils/loading/LoadingState'
import NoResults from '../components/common/error/NoResults'
import ErrorMessageText from '../components/common/error/ErrorMessageText'
import { ApplicationState } from '../application-state'
import { objectHasAnyProperty } from '../utils/commonUtils'

export default {
    name: 'rezultati-single',
    data: function () {
        return {
            rezultatiLoadingState: LoadingState.LOADING,
            userAnswersStatistics: {},
            answers: {},
            questions: {},
            answersFetched: false
        }
    },
    computed: {
        uid () {
            try {
                return this.$route.params.uid
            } catch (error) { }
            return false
        },
        quizId () {
            try {
                return this.$route.params.quizId
            } catch (error) { }
            return false
        },
        appState () {
            return this.$store.state.appState
        },
        hasAnyUserAnswers () {
            return objectHasAnyProperty(this.userAnswersStatistics.userAnswers)
        },
        userAnswersObject () {
            return Object.entries(this.userAnswersStatistics.userAnswers)
        }
    },
    mounted: async function () {
        if (this.appState !== ApplicationState.LOADING_DATA) {
            this.fetchData()
        }
        this.questions = await this.$db.quizzes.getQuizQuestions(this.quizId)
        this.answers = await this.$db.answers.getAnswers(this.quizId)
        this.answersFetched = true
    },
    watch: {
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.fetchData()
            }
        },
        userAnswersStatistics (after, before) {
            if (after.hasOwnProperty('statistics') &&
                after.hasOwnProperty('userAnswers')) {
                this.rezultatiLoadingState = LoadingState.SUCCESS
            }
        }
    },
    methods: {
        async fetchData () {
            try {
                this.userAnswersStatistics = await this.$db.answers.getUserAnswersStatistics(this.uid, this.quizId)
            } catch (error) {
                this.rezultatiLoadingState = LoadingState.ERROR
                console.log('[RezultatiSingle] fetchData error', error)
            }
        },
        getUserAnswerKey (userAnswer) {
            return this.userAnswersObject.indexOf(userAnswer)
        },
        getCorrectAnswer (userAnswer) {
            const questionId = userAnswer[0]

            if (!userAnswer.correct) {
                if (this.answersFetched) {
                    const correctAnswer = this.answers[questionId].answer
                    let questionAnswers = Object.values(this.questions[questionId].answers)
                    return questionAnswers.find((a) => a.index === Number(correctAnswer))
                }
            }
            return {}
        }
    },
    components: {
        Navbar,
        Poveznice,
        RezultatiPanel,
        RezultatiCard,
        Loading,
        NoResults,
        ErrorMessageText
    }
}
</script>

<style lang="scss" scoped>
.rezultati-single {
    padding: 22px 0 40px 0;
    .poveznice {
        margin-bottom: 46px;
    }
    .rezultati-panel {
        margin-bottom: 44px;
    }
    .rezultati-pitanja {
        margin-bottom: 50px;
    }
    .button-1 {
        display: block;
        width: 100%;
        max-width: 250px;
        margin: auto;
    }
    .no-results {
        margin-bottom: 30px;
    }
}
.error-message {
    background: white;
    border-radius: 10px;
    width: 95%;
    margin: 0 auto;
    padding: 10px;
}
/deep/ .no-results {
    h5 {
        padding: 15px 0;
    }
    background: white;
    overflow: hidden;
    border-radius: 5px;
}
@media only screen and (min-width: 800px) {
    .rezultati-single {
        max-width: 1180px;
        margin: auto;
    }
}
</style>
